var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-dialog",
    {
      staticClass: "modal-login-required",
      attrs: {
        role: "alertdialog",
        "aria-labelledby": "login-signup-required",
        show: _vm.open,
        "close-on-esc": true,
      },
      on: {
        "update:show": function ($event) {
          _vm.open = $event
        },
        hide: _vm.onClose,
      },
    },
    [
      _c(
        "silhouette-assistant",
        { attrs: { "image-name": "silhouette-3.svg", "bubble-nr": 2 } },
        [
          _c("div", { attrs: { id: "login-signup-required" } }, [
            _vm.membershipLevel < _vm.levelBasicUser
              ? _c("span", [_vm._v(_vm._s(_vm.$t("signup.signupRequired")))])
              : _vm.membershipLevel < _vm.levelRegisteredUser
              ? _c("span", [
                  _vm._v(_vm._s(_vm.$t("user.profileFeaturesComing"))),
                ])
              : _c("span", [_vm._v(_vm._s(_vm.$t("common.error")))]),
          ]),
          _c("button", { staticClass: "btn", on: { click: _vm.onClose } }, [
            _vm._v(_vm._s(_vm.$t("common.okUnderstood"))),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }